import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";
import Card from "@/components/UI/Card/Card";
import { useState } from "react";
import Button from "@/components/UI/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";
import StylePage from "./StylePage";
import DesignPage from "./DesignPage";
import MonitorPage from "./MonitorPage";
import CodePage from "./CodePage";
import { ButtonCreatorConfig } from "./utils";

interface Section27Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const Section27 = ({ job, page, section, ...props }: Section27Props) => {
  const [step, setStep] = useState(0);

  const [buttonCreatorConfig, setButtonCreatorConfig] = useState<ButtonCreatorConfig>({
    backgroundType: "white",
    buttonColor: "#1882ff",
    buttonLabel: "Notify Me",
    compareType: "visual",
    crop: { x: "218", y: "84", height: "1005", width: "586" },
    designType: "small",
    url: "",
    threshold: "1",
  });

  const handleSettingsChange = (nextSettings: ButtonCreatorConfig) => {
    setButtonCreatorConfig((previous) => {
      return {
        ...previous,
        ...nextSettings,
      };
    });
  };

  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <Card className="divide-y" rounded="large">
          <div className="flex flex-col gap-10 p-14">
            <SectionHeader section={section} />
          </div>
          {step === 0 ? (
            <DesignPage onSettingsChange={handleSettingsChange} section={section} settings={buttonCreatorConfig} />
          ) : step === 1 ? (
            <StylePage onSettingsChange={handleSettingsChange} section={section} settings={buttonCreatorConfig} />
          ) : step === 2 ? (
            <MonitorPage onSettingsChange={handleSettingsChange} section={section} settings={buttonCreatorConfig} />
          ) : step === 3 ? (
            <CodePage onSettingsChange={handleSettingsChange} section={section} settings={buttonCreatorConfig} />
          ) : null}
          <div className="flex justify-end gap-4 p-10">
            {step !== 0 && (
              <Button
                onClick={() => {
                  setStep((previous) => previous - 1);
                }}
                variant="text"
              >
                {section?.BackButton?.Value}
              </Button>
            )}
            {step !== 3 && (
              <Button
                color="primary100"
                endNode={<FontAwesomeIcon icon={faArrowRight} />}
                onClick={() => {
                  setStep((previous) => previous + 1);
                }}
              >
                {section?.NextButton?.Value}
                {": "}
                {step === 0 ? "Customize" : step === 1 ? "Monitoring Settings" : step === 2 ? "Embed Button" : null}
              </Button>
            )}
          </div>
        </Card>
      </SectionContainer>
    </Section>
  );
};

export default Section27;
